/**
 * AssessmentPage component for the assessment questionnaire
 */
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAssessmentContext } from '../context/AssessmentContext';
import AssessmentForm from '../components/AssessmentForm';

const AssessmentPage: React.FC = () => {
  const { state } = useAssessmentContext();
  const navigate = useNavigate();
  
  // Check if user info exists, redirect to contact page if not
  useEffect(() => {
    if (!state.user) {
      navigate('/assessment/contact');
    }
  }, [state.user, navigate]);
  
  const handleComplete = (assessmentId: string) => {
    // Navigate to results page
    navigate(`/assessment/results/${assessmentId}`);
  };
  
  if (!state.user) {
    return null; // Will redirect via useEffect
  }
  
  return (
    <div className="container mx-auto px-4 pb-16 pt-28 md:pt-32">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mt-6 mb-10">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            PMO Maturity Assessment
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Please answer each question based on your organization's current PMO practices.
            Select the option that best describes your situation.
          </p>
          <p className="mt-4 text-sm text-gray-500 italic max-w-2xl mx-auto">
            Disclaimer: This tool provides general insights and is not a substitute for a professional PMO assessment. Results are for informational use only.
          </p>
        </div>
        
        <AssessmentForm onComplete={handleComplete} />
      </div>
    </div>
  );
};

export default AssessmentPage;
